// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
  "aws_user_files_s3_bucket": "cave-dev",
  "aws_user_files_s3_bucket_region": "us-east-1",

  Auth: {
    // identityPoolId: "us-east-1:3eb05275-6ac6-4783-b65a-297249c852f1", 
    identityPoolId: "us-east-1:79e68dcd-3917-4480-8f57-08f50f4c8158",
    region: "us-east-1",

    oauth: {
    },
  },


  API: {
    endpoints: [
      {
        name: "SPAV",
        endpoint: "https://hrt540o6s9.execute-api.us-east-1.amazonaws.com/prod",
        region: "us-east-1",
      },
      {
        name: "Objectives",
        endpoint: "https://pwezl6ee44b46rj56px2d3n2na0khgvo.lambda-url.us-east-1.on.aws",
        region: "us-east-1",
      },
      {
        name: "OPTME",
        endpoint: "https://lnrtig5zsj.execute-api.us-east-1.amazonaws.com/prod",
        region: "us-east-1",
      },
      {
        name: "Feedback",
        endpoint: "https://gsh8w3wc88.execute-api.us-east-1.amazonaws.com/prod",
        region: "us-east-1",
      }
    ],
  }
};


export default awsmobile;
